export default __webpack_public_path__ + "static/media/audi.9b057ab6.png";